import { ArrowRightAltRounded } from '@mui/icons-material'
import { ButtonBase, Card, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useEffect, useState } from 'react'
import { ExpensesIcon, InvoiceIcon, ProfitIcon, WomanIcon } from '../../../../../atoms/icons'
import HeaderSkeleton from '../../../../common/skeletons/HeaderSkeleton'

export default function ContentHeader() {

    const [loading, setLoading] = useState(true)

    useEffect(()=>{

        setTimeout(()=>{
            setLoading(false)
        }, 1000)

    },[])
    
    return (
        
        <>
            {
                loading ? (
                    <HeaderSkeleton />
                ):(

                    <Stack direction="row" spacing={2} >

                        <Card variant="outlined" sx={styles.cardMin}>

                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <ProfitIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Total Profit</Typography>
                                        <Typography variant="h6" > GH₵ 1.2K</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                            
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <InvoiceIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Today</Typography>
                                        <Typography variant="h6" > GH₵ 1.2K</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                    <ArrowRightAltRounded htmlColor={grey[500]} />
                                </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <ExpensesIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Total Expenses</Typography>
                                        <Typography variant="h6" > GH₵ 1.2K</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <WomanIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Best Shopkeeper</Typography>
                                        <Typography variant="h6" > Adwoa Fosu</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >View employee performance</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>


                    </Stack>
                    
                )
            }
        </>
        
    )
}


const styles = {

    cardMin:{
        flex: 1, 
        height: 150, 
        borderRadius: "4px", 
        backgroundColor: 'primary.main',
        // backgroundColor: 'primary.dark',
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        padding: "1rem"
    },

}